import React from 'react';
import { Helmet } from 'react-helmet';

// eslint-disable-next-line react/prop-types
const Header = ({ shopName, customerName }) => (
  <div className="u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center">
    <Helmet>
      <title>Waiting List | {shopName}</title>
    </Helmet>
    Hey {customerName}, you have been removed from the waiting list.
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerWaitingListRemoved/components/Header.jsx